import React from "react";
import IllustrationBg from "./../assets/illustrations/illustration-1.png";

const BlogLanding = () => {
  return (
    <div className="flex justify-center flex-col md:flex-row items-center mt-12">
      <div className="self-center w-full md:w-3/5">
        <h1 className="text-dark-blue text-6xl md:text-6xl font-extrabold">
          Coming Soon - The <span className="text-myOrange">360 Believer</span>{" "}
          Blog
        </h1>
        <p className="mt-8 md:w-10/12 text-justify font-medium">
          We equip you with the right words and with accurate knowledge that
          will enable you to develop a well-rounded and robust life.
        </p>
      </div>
      <div className="w-2/5 hidden md:block">
        <img src={IllustrationBg} alt="Blog Illustration" />
      </div>
    </div>
  );
};

export default BlogLanding;

// import React from "react";
// import { PrimaryButtonOutlineWithIcon } from "./Buttons";
// import RecentPosts from "./RecentPosts";

// const BlogLanding = () => {
//   return (
//     <div className="flex flex-col md:flex-row justify-between mt-12">
//       <div className="self-center w-full md:w-3/5 text-white">
//         <div className="flex gap-4">
//           <span className="flex justify-center font-semibold">
//             🔥 Latest Blog Post
//           </span>
//         </div>
//         <div className="mt-10">
//           <h1 className="text-white text-4xl md:text-5xl w-full lg:w-10/12 font-extrabold">
//             Shoot Your Shot - Starting and Sustaining Meanngful Relationships.
//           </h1>
//         </div>
//         <div className="mt-10 flex gap-4">
//           <span className="px-6 pt-2 bg-dark-blue rounded-lg text-xs">
//             Religion
//           </span>
//           <hr className="h-8 border border-gray-500 bg-gray-500 opacity-50" />
//           <p className="text-sm self-center text-gray-500">
//             15th September, 2022
//           </p>
//         </div>
//         <div className="mt-10">
//           <PrimaryButtonOutlineWithIcon
//             btnText={"Read Article"}
//             url=""
//             icon={
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="currentColor"
//                 className="bi bi-arrow-right w-6 h-6"
//                 viewBox="0 0 16 16"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
//                 />
//               </svg>
//             }
//           />
//         </div>
//       </div>
//       <div className="flex-start">
//         <div className="mt-10 md:mt-0">
//           <RecentPosts />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BlogLanding;
